export function CALENDAR() {
	var wrap,
		label,
		months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
		currentMonth,
		currentYear,
		classMonth;

	function init(newWrap) {
		wrap = $(newWrap || "#cal");
		label = wrap.find("#label");
		wrap.find("#prev").bind("click.calendar", function () {
			switchMonth(false);
		});
		wrap.find("#next").bind("click.calendar", function () {
			switchMonth(true);
		});
		/*
		 label.bind("click", function() {
		 switchMonth(null, new Date().getMonth(), new Date().getFullYear());
		 });
		 */
		label.click();
	}

	function switchMonth(next, month, year) {
		$('#prev').hide();
		$('#next').hide();
		var curr = label.text().trim().split(" "),
			calendar,
			tempYear = parseInt(curr[1], 10);
		month = month || ((next) ? ((curr[0] === "December") ? 0 : months.indexOf(curr[0]) + 1) : ((curr[0] === "January") ? 11 : months.indexOf(curr[0]) - 1));
		year = year || ((next && month === 0) ? tempYear + 1 : (!next && month === 11) ? tempYear - 1 : tempYear);

		if (!month) {
			if (next) {
				if (curr[0] === "December") {
					month = 0;
				} else {
					month = months.indexOf(curr[0]) + 1;
				}
			} else {
				if (curr[0] === "January") {
					month = 11;
				} else {
					month = months.indexOf(curr[0]) - 1;
				}
			}
		}

		if (!year) {
			if (next && month === 0) {
				year = tempYear + 1;
			} else if (!next && month === 11) {
				year = tempYear - 1;
			} else {
				year = tempYear;
			}
		}
		console.log(month);     
		currentMonth = parseInt(month) + 1;
		currentYear = year;
		classMonth = currentMonth;
		if (/^\d$/.test(classMonth)) {
			classMonth = "0" + classMonth;
		}
		console.log(classMonth);
		
		calendar = createCal(year, month);
		$("#cal-frame", wrap).find(".curr").removeClass("curr").addClass("temp").end().prepend(calendar.calendar()).find(".temp").fadeOut("slow", function () {
			$(this).remove();
		});
		$('#label').text(calendar.label);
	}

	function createCal(year, month) {
		var day = 1,
			i,
			j,
			haveDays = true,
			startDay = new Date(year, month, day).getDay(),
			daysInMonths = [31, (((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
			calendar = [];

		if (createCal.cache[year]) {
			if (createCal.cache[year][month]) {
				return createCal.cache[year][month];
			}
		} else {
			createCal.cache[year] = {};
		}

		i = 0;
		while (haveDays) {
			calendar[i] = [];
			for (j = 0; j < 7; j++) {
				if (i === 0) {
					if (j === startDay) {
						calendar[i][j] = day++;
						startDay++;
					}
				} else if (day <= daysInMonths[month]) {
					calendar[i][j] = day++;
				} else {
					calendar[i][j] = "";
					haveDays = false;
				}
				if (day > daysInMonths[month]) {
					haveDays = false;
				}
			}
			i++;
		}

		for (i = 0; i < calendar.length; i++) {
			var row = "<tr>";
			for (j = 0; j < 7; j++) {
				if (calendar[i][j] != null && "" + calendar[i][j] !== "undefined") {
					var classDay = calendar[i][j];
					if (/^\d$/.test(classDay)) {
						classDay = "0" + classDay;
					}
					row += "<td class='" + year + "-" + classMonth + "-" + classDay + "'>" + calendar[i][j] + "</td>";
				} else {
					row += "<td>&nbsp;</td>";
				}
				//calendar[i] = "<tr><td>" + calendar[i].join("</td><td>") + "</td></tr>";
			}
			calendar[i] = row + "</tr>";
		}
		calendar = $("<table>" + calendar.join("") + "</table>").addClass("curr");

		$("td:empty", calendar).addClass("nil");
		/*
		 if (month === new Date().getMonth()) {
		 $('td', calendar).filter(function() {
		 return $(this).text() === new Date().getDate().toString();
		 }).addClass("active");
		 }
		 */

		createCal.cache[year][month] = {
			calendar: function () {
				return calendar.clone();
			},
			label: months[month] + " " + year
		};

		return createCal.cache[year][month];
	}

	function fillPriceAndKey(apiResult) {
		for (var i = 0; i < apiResult.length; i++) {
			$("td." + apiResult[i]["useDate"]).addClass('active').addClass(apiResult[i]["saleStatus"] == '已成團' ? ' gurantee' : '').addClass(apiResult[i]["saleStatus"] == '即將成團' ? ' will_gurantee' : '').append("<div class='price'><span>$" + apiResult[i]["originalPrice"] + "</span><b class='itemName' style='display: none; width: 0; height: 0'>" + apiResult[i]["itemName"] + "</b><b class='itemId' style='display: none; width: 0; height: 0'>" + apiResult[i]["itemId"] + "</b></div>");
		}
	}

	function checkMonthAndYear(minMonth, minYear, maxMonth, maxYear) {
		if (currentYear > minYear)
			$('#prev').show();
		if (currentYear < maxYear)
			$('#next').show();
		if (currentMonth > minMonth && currentYear >= minYear)
			$('#prev').show();
		if (currentMonth < maxMonth && currentYear <= maxYear)
			$('#next').show();
	}


	createCal.cache = {};

	return {
		init: init,
		switchMonth: switchMonth,
		fillPriceAndKey: fillPriceAndKey,
		checkMonthAndYear: checkMonthAndYear,
		createCal: createCal
	};
}


export default CALENDAR;
